import React, { useEffect, useState } from 'react';
import { Card, Steps, Button, Spin } from 'antd';
import { useSelector } from "react-redux";

// import './app.css'; // make sure you import your CSS file

const RecordPath = ({
  picklistValues,
  currentStatus,
  completeStep,
  setSelectedIndex,
  selectedIndex,
  updateStatus,
  objectName,
  fieldName
}) => {
  const [currentIndex, setCurrentIndex] = useState(-1);
  const security = useSelector((state) => state.data.items[0]);
  const [fieldSecurityEditable, setFieldSecurityEditable] = useState(false);
  useEffect(() => {
    const currentIndex = picklistValues?.findIndex((value) => value === currentStatus) ?? -1;
    setCurrentIndex(currentIndex);
    console.log('RecordPath picklistValues isss:', picklistValues);
    const isFieldSecurityEditable = security?.object_settings?.[objectName]?.field_setting?.[fieldName]?.edit;
    setFieldSecurityEditable(isFieldSecurityEditable);
  }, [currentStatus, picklistValues]);


  // if (!picklistValues?.length) {
  //   return <Spin size="small" />;
  // }

  const handleStepClick = (index) => {
    if (index === currentIndex) {
      setSelectedIndex(null);
    } else {
      setSelectedIndex(index);
    }
  };

  const getButtonLabel = () => {
    console.log('getButtonLabel selectedIndex:', selectedIndex, 'currentIndex:', currentIndex);
    if (selectedIndex === null || selectedIndex === currentIndex) {
      return 'Mark Current Step Completed';
    }
    return `Move to "${picklistValues?.[selectedIndex]}"`;
  };

  const handleCompleteStep = () => {
    console.log('handleCompleteStep selectedIndex:', selectedIndex, 'currentIndex:', currentIndex);
    console.log('acces of the field is ::', fieldSecurityEditable);
    // return;
    if (selectedIndex === null || selectedIndex === currentIndex) {
      updateStatus(currentIndex + 1);
    } else {
      updateStatus(selectedIndex);
    }
  };

  return (
    <Card className="record-path-card" style={{ borderRadius: 7 }}>
      <div className="record-path-container">
        <Steps
          current={currentIndex}
          items={picklistValues?.map((value, index) => ({
            title: value,
            status:
              index < currentIndex
                ? 'finish'
                : index === currentIndex
                ? 'process'
                : 'wait',
            className: selectedIndex === index ? 'highlighted-step' : ''
          }))}
          onChange={handleStepClick}
        />

        <div className="record-path-button-wrapper">
          <Button
            type="primary"
            onClick={handleCompleteStep}
            disabled={!fieldSecurityEditable || (selectedIndex === null && currentIndex === -1)}
            >
            {getButtonLabel()}
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default RecordPath;
